<template>
  <svg class="icon icon--autoplay" wclassth="60px" height="63px" viewBox="0 0 63 66" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs></defs>
    <g class="Page-1" stroke="none" stroke-wclassth="1" fill="none" fill-rule="evenodd">
      <g class="02_Home_d" transform="translate(-282.000000, -399.000000)" stroke-wclassth="2" stroke="#FFFFFF">
        <g class="Guclassed-Mode" transform="translate(251.000000, 322.000000)">
          <g class="Group-3" transform="translate(27.000000, 78.000000)">
            <g class="Autoplay-Mode">
              <g class="Autoplay-Icon" transform="translate(5.733333, 0.828916)">
                <polygon class="Shape i" points="24.4146092 45.1165961 40.4405584 34.7039507 24.3832779 24.3392163"></polygon>
                <polyline class="Shape" points="11.2995678 0 20.8149933 4.00298143 17.1027652 14.2473461"></polyline>
                <path d="M19.9565921,4.74911538 C6.34088151,9.58684077 -1.88860687,23.4137638 0.372027079,37.6544748 C2.63266103,51.8951857 14.7420193,62.5092409 29.1899198,62.9138402 C43.6378203,63.3184394 56.3250346,53.3987878 59.3829964,39.3070188 C62.4409582,25.2152499 55.0020477,10.9495488 41.6798513,5.35745385" class="Shape"></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
  export default{
    data(){
      return{}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/icons/Autoplay.vue